<template>
  <v-app style="background-color: transparent;padding: 0;height: 100%;">
    <v-container style="background-color: transparent;height: 100%;padding: 0">
      <v-row class="parabola" style="height: 25%;background: white; text-align: center; justify-content: center">
        <v-dialog transition="dialog-bottom-transition" max-width="600px">
          <template v-slot:activator="{ on }">
            <v-icon style="position: absolute; top: 10px; right: 20px;" v-on="on">
              mdi-earth
            </v-icon>
          </template>
          <template v-slot:default="dialog">
            <v-card class="dialogResetLanguage" dark>
              <h3 class="title-center">
                <br>{{ $t('Login.LanguageTitle') }}
              </h3>
              <v-card-text>
                <v-list color="primary" dark>
                  <v-list-item
                    v-for="(item, index) in languages"
                    :key="index"
                    @click="changeLanguage(item.title)"
                  >
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
          </template>
        </v-dialog>
        <button class="v-btn-icon" @click="undo">
          <v-icon
            style="position: absolute; top: 10px; left: 15px;cursor: pointer;">
            mdi-undo-variant
          </v-icon>
        </button>
        <div style="align-self: center">
          <v-img src="/logo-dark.png" style="width: 30vh;margin-top: 30px" /><br>
          <h2 class="titol">
            {{ $t('RegisterLayout.Title') }}
          </h2>
        </div>
      </v-row>
      <v-row style="height: 70%;background: transparent!important; justify-content: center;text-align: center;align-content: center;overflow-y: scroll">
        <router-view :style="{ minHeight: '100%', height: '100%'}" style="background: transparent;" />
      </v-row>
      <v-dialog v-model="loading" width="450">
        <v-card>
          <v-card-text class="pa-0" style="text-align: justify;">
            <Loading />
          </v-card-text>
        </v-card>
      </v-dialog>
      <!--      <v-footer color="base" app style=" height:5%;background-color: #FFFFFF; font-size: 14px; position: absolute; padding: 20px 6px 6px">
        <h5>Byppay 2023 &copy;</h5>
        <h5 class="pointer" @click="privacyPolicy">
          {{ $t('|Policies') }}
        </h5>
        <v-spacer />
      </v-footer>-->
    </v-container>
  </v-app>
</template>

<script>

import LocalRepository from "../repositories/LocalRepository";
import Loading from "../components/Loading";
import Constants from "../../constants";
import ApiRepository from "../repositories/ApiRepository";
import AuthRepository from "@/repositories/AuthRepository";

export default {
    name: 'RegisterLayout',
    components: {Loading},
    data () {
        return {
            languages: [
                { title: this.$t('Catalan') },
                { title: this.$t('Spanish') },
                { title: this.$t('English') },
            ],
            loading: false,
            valid: false,
            name: '',
            surname: '',
            phone: '',
            email: '',
            address: '',
            cif: '',
            password: '',
            country: 'Spain',
            loadingRegister: false,
            selected: false,
            items: [
                'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Australia', 'Austria',
                'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Bolivia', 'Bosnia and Herzegovina',
                'Botswana', 'Brazil', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Côte d\'Ivoire', 'Cabo Verde', 'Cambodia', 'Cameroon',
                'Canada', 'Central African Republic', 'Chad', 'Chile', 'China', 'Colombia', 'Comoros', 'Congo', 'Costa Rica', 'Croatia', 'Cuba',
                'Cyprus', 'Czechia', 'Democratic Republic of the Congo', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador',
                'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Eswatini', 'Ethiopia', 'Fiji', 'Finland', 'Gabon', 'Gambia',
                'Georgia', 'Germany', 'Ghana', 'Greece', 'Grenada', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Hati', 'Holy See', 'Honduras',
                'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jordan', 'Kazakhstan',
                'Kenya', 'Kiribati', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechetenstein', 'Lithuania',
                'Luxembourg', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius', 'Mexico',
                'Micronesia', 'Moldova', 'Mongolia', 'Montenegro', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands',
                'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'North Korea', 'North Macedonia', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Palestine State',
                'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Qatar', 'Romania', 'Russia', 'Rwanda', 'Saint Kitts and Nevis',
                'Saint Lucia', 'Saint Vincent and the Greandines', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles',
                'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Korea', 'South Sudan', 'Spain', 'Sri Lanka',
                'Sudan', 'Suriname', 'Sweden', 'Switzerland', 'Syria', 'Tajikistan', 'Tanzania', 'Thailand', 'Timor-Leste', 'Togo', 'Tonga', 'Trinidad and Tobago', 'Tunisia',
                'Turkey', 'Turkmenistan', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States of America', 'Uruguay', 'Uzbekistan',
                'Vanuatu', 'Venezuela', 'Vietnam', 'Yemen', 'Zambia', 'Zimbabwe'
            ],
            rules: {
                name: [val => (val || '').length > 0 || this.$t('Error.This field is required')],
                surname: [val => (val || '').length > 0 || this.$t('Error.This field is required')],
                phone: [ v => /^(\+?[\d ]{9,}|)$/.test(v) || this.$t('The phone must be valid') ],
                email: [
                    v => !!v || this.$t('Error.The mail field is required'),
                    v => /.+@.+\..+/.test(v) || this.$t('The mail must be valid.')],
                cif: [
                    val => (val || '').length > 0 || this.$t('Error.This field is required'),
                ],
                password: [
                    val => (val || '').length > 0 || this.$t('Error.This field is required'),
                    v => /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z-A-Z]).{6,}$/.test(v) || this.$t('The password must be valid')
                ]
            },

        };
    },
    computed: {
    },
    watch: {
        $route () {
            this.refreshCookiePolicity();
        },
    },
    created () {
        console.log(this.$t('RegisterLayout.Title'));
        const cifLoginRepository = LocalRepository.get('cif-user-compensation');
        if (cifLoginRepository) {
            this.cif = cifLoginRepository;
        }
        const emailLoginUser = localStorage.getItem('email-user-compensation');
        if (emailLoginUser) {
            this.email = emailLoginUser;
        }
        if (this.$user) {
            this.name = this.$user.name;
            this.cif = this.$user.cif;
            this.email = this.$user.email;
        }
        if (this.$user) {
            this.$socket.emit('LOGIN', {id: this.$user._id});
        }
        const initialDark = LocalRepository.get('dark');
        if (initialDark) {
            this.$data.darkMode = initialDark.dark;
        }
        this.$root.$on('start-loading', () => {
            this.loading = true;
        });
        this.$root.$on('stop-loading', () => {
            this.loading = false;
        });

        const showCookieConsent = localStorage.getItem('show-cookies-banner');
        if (showCookieConsent) {
            this.showCookieConsent = showCookieConsent !== "false";
        } else {
            this.showCookieConsent = true;
        }
        this.refreshCookiePolicity();
    },
    methods: {
        onSubmit () {
            this.loadingRegister = true;
            AuthRepository.register(this.cif, this.email, this.password, this.name, localStorage.getItem('language'))
                .then((response) => {
                    if (response && response.data && response.data.token) {
                        this.$router.push({name: 'Login', params: {message: this.$t('Register.Registered succesfully! Please check your email for the validation'), color: "success"}, replace: true});
                    }
                    this.loadingRegister = false;
                })
                .catch((err) => {
                    let missatge = "";
                    if (err.response.data.errorCode === Constants.ERRORS.ERROR_SAVING_USER) {
                        missatge = this.$t('Register.ERROR: The user couldn\'t be saved');
                    } else if (err.response.data.errorCode === Constants.ERRORS.ERROR_SAME_MAIL) {
                        missatge = this.$t('Regsiter.ERROR: E-mail already in use');
                    } else if (err.response.data.errorCode === Constants.ERRORS.ERROR_SAME_CIF) {
                        missatge = this.$t('Register.ERROR: CiF already in use');
                    }
                    this.$root.$emit('show-snackbar', {message: missatge, color: "error"});
                    console.log("error: " + err.response.data.error);
                    this.loadingRegister = false;
                });
        },
        goLogin () {
            this.$router.push({name: 'Login', replace: true});
        },
        onCancel () {
            this.$router.push({name: 'LandingPage', replace: true});
        },
        undo () {
            this.$router.push({name: 'LandinPage', params: {}, replace: true});
        },
        changeLanguage (lang) {
            let language = '';
            if (lang === 'Catalan' || lang === 'Català' || lang === 'Catalán') language = 'ca';
            if (lang === 'Spanish' || lang === 'Castellà' || lang === 'Español') language = 'es';
            if (lang === 'English' || lang === 'Anglès' || lang === 'Inglés') language = 'en';
            ApiRepository.changeLanguage(language)
                .then(() => {

                })
                .catch((err) => {
                    this.$root.$emit('show-snackbar', {message: this.$t('Error changing language'), color: 'error'});
                    console.error(err);
                });
            localStorage.setItem('language', language);
            location.reload();
        },
        refreshCookiePolicity () {
            this.hideOverlay = this.$router.history.current.name === 'CookiePolicy';
        },
        privacyPolicy () {
            this.$router.push({name: 'PrivacyPolicy', replace: true});
        },
    },
    sockets: {
        CONNECTION_SOCKET (socket) {
            LocalRepository.set('connectionSocket', socket);
        }
    },
};
</script>

<style scoped>
.dialogResetLanguage{
  position: absolute;
  margin: auto;
  border-top-left-radius: 70px;
  border-top-right-radius: 70px;
  left: 0;
  right: 0;
  bottom: 0;
  max-width: 600px;
  height: 40%;
  text-align: center;
  background: rgba(67, 225, 178, 0.95);
}
</style>
